import { Icon } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled/macro';
import { ReactComponent as GearIcon } from '../../icons/mdi-cog-outline.svg';

/**
 * cellRenderer: 'DataGridButton' used in components list in DataGrid and in DataGridReadOnly AG Grids.
 * props.data has the raw Data values of the row.
 * props.colDef?.headerName has the column name/title.
 */
const DataGridButton = (props) => {
    return (
        <ButtonWrapper>
            {props.icon || <Icon as={GearIcon} />}
            <span>{props.children || <FormattedMessage id="datagrid_edit_child_table_button_title" />}</span>
        </ButtonWrapper>
    );
};

const ButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    text-transform: capitalize;
    color: var(--chakra-colors-ag-cell-color);
    font-size: 14px;
    cursor: pointer;

    svg {
        font-size: 24px;
        margin-right: 8px;
    }

    &:hover svg path {
        fill: var(--chakra-colors-blue-400);
    }

    span {
        color: var(--chakra-colors-ag-cell-color-readonly);
    }
`;

export default DataGridButton;
